import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CompanyService, Company, CompanyData } from '../../services/company.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Upload } from '../../services/upload/upload';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-update-company',
  templateUrl: './update-company.component.html',
  styleUrls: ['./update-company.component.css']
})
export class UpdateCompanyComponent implements OnInit, OnDestroy {

  company: any;
  company$: Observable<any[]>;
  companyForm: FormGroup;

  fiscalRegimenSelect: any[] = [];

  selectedFile: File;
  currentUpload: Upload;

  sub: Subscription;

  constructor(private companyService: CompanyService, private companyData: CompanyData, private fb: FormBuilder,) {
    this.fiscalRegimenSelect = Object.keys(companyData.fiscalRegimenSelect).map(key => ({value: key, name: companyData.fiscalRegimenSelect[key].full}) )
  }

  ngOnInit() {
    this.createForm();
    this.sub = this.companyService.getCompany().subscribe(company => {
      this.company = company;
      this.companyForm.get('name').setValue(company.name);
      this.companyForm.get('phoneOne').setValue(company.phoneOne);
      this.companyForm.get('phoneTwo').setValue(company.phoneTwo || '');
      this.companyForm.get('email').setValue(company.email);
      this.companyForm.get('webPage').setValue(company.webPage || '');
      this.companyForm.get('socialReason').setValue(company.socialReason);
      this.companyForm.get('RFC').setValue(company.RFC);
      this.companyForm.get('street').setValue(company.street);
      this.companyForm.get('numExt').setValue(company.numExt);
      this.companyForm.get('numInt').setValue(company.numInt || '');
      this.companyForm.get('colony').setValue(company.colony);
      this.companyForm.get('municipality').setValue(company.municipality);
      this.companyForm.get('city').setValue(company.city);
      this.companyForm.get('postCode').setValue(company.postCode);
      //this.companyForm.get('country').setValue(company.country);
      this.companyForm.get('fiscalRegimen').setValue(company.fiscalRegimen || 'key0');
      this.companyForm.get('supAddress').setValue(company.supAddress || '');
      this.companyForm.get('supNotes').setValue(company.supNotes || '');
      this.companyForm.get('satPrivateKey').setValue(company.satPrivateKey || '');
      
    })
  }
  ngOnDestroy(){
    this.sub.unsubscribe();
  }
  
  createForm(){
    this.companyForm = this.fb.group({
      name: ['', Validators.required],
      //location: [company.location, Validators.required],
      phoneOne: ['', Validators.required],
      phoneTwo: [''],
      email: ['', [Validators.required,Validators.email]],
      webPage: '',

      socialReason: ['', Validators.required],
      RFC: ['', Validators.required],

      street: ['', Validators.required],
      numExt: ['', Validators.required],
      numInt: [''],
      colony: ['', Validators.required],
      municipality: ['', Validators.required],
      city: ['', Validators.required],
      postCode: ['', Validators.required],
      //country: ['', Validators.required],

      fiscalRegimen: 'key0',
      satPrivateKey: '',

      supAddress: '',
      supNotes: '',

    });
  }
  onSubmit({ value, valid }: { value: any, valid: boolean }){
    console.log(value);
    this.companyService.updateCompany(value);
  }
  
  uploadImage(event) {
    this.selectedFile = event.target.files[0];
    this.currentUpload = new Upload(this.selectedFile);
    this.companyService.uploadImage(this.currentUpload,this.company);
  }

  uploadFile(event) {
    var selectedFile: File = event.target.files[0];
    var currentUpload: Upload = new Upload(selectedFile);
    this.companyService.uploadFile(currentUpload, this.company, selectedFile.name);
  }

  deleteFile(index){
    this.companyService.deleteFile(this.company, index);
  }

}
